export const ELEMENT_TYPES = {
  input: {
    label: 'Input',
    value: 'INPUT'
  },
  address: {
    label: 'Address',
    value: 'ADDRESS'
  },
  date: {
    label: 'Date',
    value: 'DATE'
  },
  phone: {
    label: 'Phone',
    value: 'PHONE'
  },
  email: {
    label: 'Email',
    value: 'EMAIL'
  },
  radio: {
    label: 'Radio',
    value: 'RADIO'
  },
  checkbox: {
    label: 'Checkbox',
    value: 'CHECKBOX'
  },
  docUpload: {
    label: 'Doc upload',
    value: 'DOC_UPLOAD'
  },
  country: {
    label: 'Country',
    value: 'COUNTRY'
  },
  confirmations: {
    label: 'Confirmations',
    value: 'CONFIRMATIONS'
  },
  signature: {
    label: 'Signature',
    value: 'SIGNATURE'
  },
  text: {
    label: 'Text',
    value: 'TEXT'
  },
  agentCode: {
    label: 'Agent or assistant code',
    value: 'AGENT_CODE'
  },
  float: {
    label: 'Float',
    value: 'FLOAT'
  },
  sum: {
    label: 'Sum',
    value: 'SUM'
  }
};

export const ELEMENT_PRODUCT_TYPES = {
  input: {
    label: 'Input',
    value: 'INPUT'
  },
  address: {
    label: 'Address',
    value: 'ADDRESS'
  },
  date: {
    label: 'Date',
    value: 'DATE'
  },
  phone: {
    label: 'Phone',
    value: 'PHONE'
  },
  email: {
    label: 'Email',
    value: 'EMAIL'
  },
  radio: {
    label: 'Radio',
    value: 'RADIO'
  },
  checkbox: {
    label: 'Checkbox',
    value: 'CHECKBOX'
  },
  docUpload: {
    label: 'Doc upload',
    value: 'DOC_UPLOAD'
  },
  country: {
    label: 'Country',
    value: 'COUNTRY'
  },
  confirmations: {
    label: 'Confirmations',
    value: 'CONFIRMATIONS'
  },
  signature: {
    label: 'Signature',
    value: 'SIGNATURE'
  },
  text: {
    label: 'Text',
    value: 'TEXT'
  },
  iban: {
    label: 'IBAN',
    value: 'IBAN'
  },
  swift: {
    label: 'SWIFT',
    value: 'SWIFT'
  },
  integer: {
    label: 'Integer',
    value: 'INTEGER'
  },
  minimalAmount: {
    label: 'Minimal amount',
    value: 'MINIMAL_AMOUNT'
  },
  currency: {
    label: 'Currency',
    value: 'CURRENCY'
  }
};
